"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLibraryLoaded = exports.useHeapLoad = exports.useDynatraceLoad = void 0;
var _react = require("react");
var _Context = require("../Context");
var actions = _interopRequireWildcard(require("../../actions"));
var _constants = require("./constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useLibraryLoaded = (checkCondition, checkInterval = _constants.DEFAULT_LIB_LOAD_CHECK_INTERVAL, maxRetries = _constants.LIB_LOAD_MAX_RETRIES) => {
  const [state, setState] = (0, _react.useState)({
    loaded: checkCondition(),
    timeout: false
  });
  const retriesRef = (0, _react.useRef)(0);
  const checkLibrary = (0, _react.useCallback)(() => {
    const isLoaded = checkCondition();
    if (isLoaded && !state.loaded) {
      setState({
        loaded: true,
        timeout: false
      });
      return true;
    }
    return isLoaded;
  }, [checkCondition, state.loaded]);
  (0, _react.useEffect)(() => {
    const intervalId = setInterval(() => {
      const found = checkLibrary();
      retriesRef.current += 1;
      const reachedMaxRetires = retriesRef.current >= maxRetries;
      const shouldClearInterval = found || reachedMaxRetires;
      if (reachedMaxRetires) {
        setState(prev => {
          if (prev.timeout) return prev;
          return {
            ...prev,
            timeout: true
          };
        });
      }
      if (shouldClearInterval) {
        clearInterval(intervalId);
      }
    }, checkInterval);
    return () => clearInterval(intervalId);
  }, [checkLibrary, state.loaded, checkInterval, maxRetries]);
  return [state.loaded, state.timeout];
};
exports.useLibraryLoaded = useLibraryLoaded;
const useDynatraceLoad = () => {
  const isDynatraceAvailable = (0, _react.useCallback)(() => !!window.dtrum, []);
  const [loaded, timeout] = useLibraryLoaded(isDynatraceAvailable);
  const dispatch = (0, _Context.useDispatch)();
  (0, _react.useEffect)(() => {
    if (loaded) dispatch(actions.dynatraceLoadSuccess());
    if (!loaded && timeout) dispatch(actions.dynatraceLoadError());
  }, [dispatch, loaded, timeout]);
};
exports.useDynatraceLoad = useDynatraceLoad;
const useHeapLoad = heapAppId => {
  const isHeapIoAvailable = (0, _react.useCallback)(() => {
    var _window$heap;
    return heapAppId && ((_window$heap = window.heap) === null || _window$heap === void 0 ? void 0 : _window$heap.loaded);
  }, [heapAppId]);
  const [loaded, timeout] = useLibraryLoaded(isHeapIoAvailable);
  const dispatch = (0, _Context.useDispatch)();
  (0, _react.useEffect)(() => {
    if (loaded) dispatch(actions.heapLoadSuccess());
    if (!loaded && timeout) dispatch(actions.heapLoadError());
  }, [dispatch, loaded, timeout]);
};
exports.useHeapLoad = useHeapLoad;